// src/api/modules/InquiriesApi.js
import Methods from "../methods";
import dateformat from 'dateformat';
import {formatDate} from "../../util/date-util";

const searchInquiries = (context, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/inquiries/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const getInquiryById = (context, id) => {
  const url = `api/inquiries/${id}`;
  return Methods.doGet(context, url);
};

const changeStatusInquiry = (context, idInquiry, request) => {
  const url = `api/inquiries/${idInquiry}/status`;
  return Methods.doPut(context, url, request, null);
};

const exportInquiriesExcel = (context, filters) => {
  const url = `report/inquiries/export-excel`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_consultas_${newDate}.xlsx`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportInquiriesPdf = (context, filters) => {
  const url = `report/inquiries/export-pdf`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_consultas_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportInquiriesDetailExcel = (context, filters) => {
  const url = `report/inquiries/export-detail-excel`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_detallado_consultas_${newDate}.xlsx`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportInquiriesDetailPdf = (context, filters) => {
  const url = `report/inquiries/export-detail-pdf`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_detallado_consultas_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const loadReportInquiries = (context, payload) => {
  const url = `report/inquiries/${payload.inquiries.id}`;
  return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `reporte-consulta-${payload.nameClient}-${dateformat(payload.inquiries.registrationDate, "dd-mm-yyyy")}`, null)
}

const loadReportInquiriesExcel = (context, payload) => {
  const url = `report/inquiries/${payload.inquiries.id}/excel`;
  return Methods.doPostDonwload(context, url, {extExport: 'xlsx'}, `reporte-consulta-${payload.nameClient}-${dateformat(payload.inquiries.registrationDate, "dd-mm-yyyy")}`, null)
}

export default {
  loadReportInquiries,
  loadReportInquiriesExcel,
  searchInquiries,
  getInquiryById,
  changeStatusInquiry,
  exportInquiriesExcel,
  exportInquiriesPdf,
  exportInquiriesDetailExcel,
  exportInquiriesDetailPdf,
}



// WEBPACK FOOTER //
// ./src/api/modules/InquiriesApi.js